import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DEFAULT_COURSE_CREATOR_STEPS, StepperStep } from '../../../models';

@Component({
  selector: 'app-course-stepper',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './course-stepper.component.html',
  styleUrl: './course-stepper.component.scss',
})
export class CourseStepperComponent {
  currentStep = input<string>('settings');
  completedSteps = input<string[]>([]);
  /** Steps that cannot be navigated to (e.g. locked after publish) */
  lockedSteps = input<string[]>([]);

  steps = input<StepperStep[]>(DEFAULT_COURSE_CREATOR_STEPS);

  stepClicked = output<string>();

  isStepActive(stepId: string): boolean {
    return this.currentStep() === stepId;
  }

  isStepCompleted(stepId: string): boolean {
    return this.completedSteps().includes(stepId);
  }

  canNavigateToStep(stepId: string): boolean {
    if (this.lockedSteps().includes(stepId)) return false;

    const stepIndex = this.steps().findIndex((s) => s.id === stepId);
    if (stepIndex === 0) return true; // First step is always accessible

    // Check if all previous steps are completed
    for (let i = 0; i < stepIndex; i++) {
      if (!this.isStepCompleted(this.steps()[i].id)) {
        return false;
      }
    }
    return true;
  }

  onStepClick(stepId: string): void {
    if (this.canNavigateToStep(stepId)) {
      this.stepClicked.emit(stepId);
    }
  }

  getStepIcon(step: StepperStep): string {
    if (this.isStepCompleted(step.id)) {
      return '/public/svgs/done.svg';
    }
    return `/public/svgs/${step.icon}.svg`;
  }
}
